import { render, staticRenderFns } from "./BriefDetailIcon.vue?vue&type=template&id=4beef830&scoped=true"
import script from "./BriefDetailIcon.vue?vue&type=script&lang=js"
export * from "./BriefDetailIcon.vue?vue&type=script&lang=js"
import style0 from "./BriefDetailIcon.vue?vue&type=style&index=0&id=4beef830&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beef830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4beef830')) {
      api.createRecord('4beef830', component.options)
    } else {
      api.reload('4beef830', component.options)
    }
    module.hot.accept("./BriefDetailIcon.vue?vue&type=template&id=4beef830&scoped=true", function () {
      api.rerender('4beef830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/briefs/BriefDetailIcon.vue"
export default component.exports